/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { Submission } from './submission';

export type GenericApiResponseSubmissionData = Submission | null;
